import { Typography } from "antd";
import React, { useRef } from "react";
import { useIntl } from "react-intl";
import SeriesList from "./SeriesList";

const SeriesTab = () => {
  const { formatMessage } = useIntl();
  const reloadSeriesRef = useRef(null);

  return (
    <>
      <Typography.Title level={4}>
        {formatMessage({
          id: "series",
          defaultMessage: "Series",
        })}
      </Typography.Title>
      <SeriesList reloadSeriesRef={reloadSeriesRef} />
    </>
  );
};

export default SeriesTab;
